import React from 'react';
import ProductEditor from '../components/database/producteditor';


export default function EditorPage() {
    return <ProductEditor />;
}